import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_64: FaireProductEntity = {
  token: "legacy_prod_abbott-64",
  type: "product",
  name: "Autumn Harvest Lined Notebook 6×8 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5533d64412dd53e1b3eee8b60d6149ad4ce6721bc6908d4ed1c699d8da4babf7.jpeg",
  priceDollars: 9,
  msrpDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
